import React from "react";
import { useTranslation } from "react-i18next";
import { HeroRewardsBonus } from "@components/HeroRewardsBonus";
import { BenefitsList } from "@components/BenefitsList";
import { Footer } from "@components/Footer";
import { Header } from "@components/Header";

/**
 * Example screen showing how to use HeroRewardsBonus and BenefitsList components
 * with internationalization support
 */
export function VersionB() {
  const { t } = useTranslation();

  // Prepare rewards data from i18n
  const rewards = [
    {
      value: t("heroRewardsBonus.rewards.activation.value"),
      title: t("heroRewardsBonus.rewards.activation.title"),
      subtitle: t("heroRewardsBonus.rewards.activation.subtitle"),
    },
    {
      value: t("heroRewardsBonus.rewards.monthly.value"),
      title: t("heroRewardsBonus.rewards.monthly.title"),
      subtitle: t("heroRewardsBonus.rewards.monthly.subtitle"),
    },
  ];

  // Prepare benefits data from i18n
  const benefits = [
    {
      title: t("benefitsList.benefits.guesswork.title"),
      description: t("benefitsList.benefits.guesswork.description"),
    },
    {
      title: t("benefitsList.benefits.rxSpend.title"),
      description: t("benefitsList.benefits.rxSpend.description"),
    },
    {
      title: t("benefitsList.benefits.clinical.title"),
      description: t("benefitsList.benefits.clinical.description"),
    },
    {
      title: t("benefitsList.benefits.getPaid.title"),
      description: t("benefitsList.benefits.getPaid.description"),
    },
  ];

  return (
    <div className="w-full flex flex-col items-center font-sans">
      <div
        className="w-full flex flex-col items-center font-sans"
        style={{
          background: "linear-gradient(135deg, #FFFFFF 0%, #f4f2ff 100%)",
        }}
      >
        <Header />

        <HeroRewardsBonus
          title={t("heroRewardsBonus.title")}
          description={t("heroRewardsBonus.description")}
          rewards={rewards}
          buttonText={t("heroRewardsBonus.buttonText")}
          subtitleText={t("heroRewardsBonus.subtitleText")}
          imageSrc="/images/screen-meet-pharmacist.png"
          imageAlt={t("heroRewardsBonus.imageAlt")}
          appleButtonSrc="/images/app-store-dark.png"
          googleButtonSrc="/images/play-store-dark.png"
        />
      </div>

      <BenefitsList title={t("benefitsList.title")} benefits={benefits} />

      <Footer
        appleButtonSrc="/images/app-store-dark-old.svg"
        googleButtonSrc="/images/play-store-dark-old.svg"
      />
    </div>
  );
}
